module.exports = __webpack_public_path__ + "static/media/my-atrias.d71edbcf.jpg";